import type { Configuration } from '@repo/api-gw-sdk';
import { VaultsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const redshiftAccess = (
  _httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const vaultsApi = new VaultsApi(config);

  return {
    createAccessPoint: (vaultId: string, redshiftRoleArn: string) =>
      vaultsApi.createRedshiftAccessPoint(currentProjectId, {
        vaultId,
        redshiftRoleArn,
      }),
  };
};
